
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    formModel: {
      type: Object,
      default: () => {
        return null
      }
    },
    formStruct: {
      type: Array,
      default: () => []
    },
    formRules: {
      type: Object,
      default: () => {
        return null
      }
    },
    submitButton: {
      type: String,
      required: false,
      default: 'common.submit'
    },
    resetButton: {
      type: String,
      required: false,
      default: 'common.reset'
    }
  },
  emits: ['submit', 'reset'],
  setup(props, context) {
    const { t } = useI18n()
    const sFormRef = ref()
    const fM = ref(props.formModel)
    const fS = ref(props.formStruct)
    const bOffset = () => {
      if ((props.formStruct.length % 2) === 0) {
        return 2
      }
      return 11
    }
    const submitEmit = () => {
      context.emit('submit')
    }
    const resetEmit = () => {
      sFormRef.value.resetFields()
      context.emit('reset')
    }
    return {
      t,
      fM,
      fS,
      sFormRef,
      bOffset,
      submitEmit,
      resetEmit
    }
  }
})
